import React from "react";
import { Grid } from "@material-ui/core";
import { CcsReviewPanel } from "../components";
import { INewRxStepHandoff } from "../types/PrescriptionIngestionTypes";

type FollowUpFlow = "newRx" | "transferRx";

const FLOW_TEXT: Record<FollowUpFlow, { title: string; routedTitle: string; readyHint: string }> = {
  newRx: {
    title: "3. Route to Follow-Up",
    routedTitle: "3. Routed to Follow-Up",
    readyHint:
      "Please continue with this step after 2 mins once step 2 above is done (the prescription needs to reach RphCheck in CCS).",
  },
  transferRx: {
    title: "Route TransferRx to Follow-Up",
    routedTitle: "TransferRx Routed to Follow-Up",
    readyHint:
      "Continue about 2 mins after the TransferRx is ingested (the prescription needs to reach RphCheck in CCS).",
  },
};

interface IProps {
  flow?: FollowUpFlow;
  handoff?: INewRxStepHandoff;
}

const RouteToFollowUpStepSection: React.FC<IProps> = ({ flow = "newRx", handoff }) => (
  <Grid container direction="column" spacing={3} style={{ marginTop: 8 }}>
    <CcsReviewPanel mode="followUp" {...FLOW_TEXT[flow]} handoff={handoff} />
  </Grid>
);

export default RouteToFollowUpStepSection;
